var m = require('mithril');

module.exports = {
  view: function (vnode) {
    return m('div.pv2.bg-moon-gray.black.mt2.ph2.flex.justify-between', {class: vnode.attrs.class, onclick: vnode.attrs.onclick}, [
      m('div.flex.justify-between', {class: vnode.attrs.labelClass, onclick: vnode.attrs.onclickLabel}, vnode.attrs.label),
      m('div.flex.items-center', vnode.children)
    ]);
  }
};
